import { BaseApi } from '@/main/baseApi';

import { API_ND_AREA, API_NAME,  EXPORT_FILE_NAME } from './constants';
class AbcFmsAnalysisProvider extends BaseApi {
	constructor() {
		super(API_ND_AREA, API_NAME);
	}

	async GetAbcFmsAnalysisReport(createdFrom: any, createdTo: any, loggedUserId: any, saleAbcFms:any, OrganizationId: string, columnSequence: any) {
		return this.downloadXlsxReport(`/${API_ND_AREA}/${API_NAME}/GetAbcFmsAnalysisReport?createdFrom=${createdFrom}&createdTo=${createdTo}
			&loggedUserId=${loggedUserId}&saleAbcFms=${saleAbcFms}${OrganizationId}&ColumnSequence=${columnSequence}`, EXPORT_FILE_NAME);
	}
}


export const apiProvider = new AbcFmsAnalysisProvider();
